<template>
    <div>
        <vk-tabs-vertical v-if="cliente && ! isMobile()">
            <vk-tabs-item title="DADOS DO CLIENTE">
                <form-cliente :cliente="cliente"  :edit="false" :showFinanceiro="false"/>
            </vk-tabs-item>
            <vk-tabs-item title="TELEFONE DO CLIENTE">
                <table-telefones-clientes :height="null" :telefones="cliente.telefones" :edit="false"></table-telefones-clientes>
            </vk-tabs-item>
        </vk-tabs-vertical>
        <vk-tabs v-else-if="cliente" align="justify">
            <vk-tabs-item title="DADOS BÁSICOS">
                <form-cliente :cliente="cliente"  :edit="false" :showFinanceiro="false"/>
            </vk-tabs-item>
            <vk-tabs-item title="TELEFONES">
                <table-telefones-clientes :height="null" :telefones="cliente.telefones" :edit="false"></table-telefones-clientes>
            </vk-tabs-item>
        </vk-tabs>
    </div>

</template>

<script>
import TableTelefonesClientes from '../../tables/TableTelefonesClientes.vue';
import FormCliente from '../../forms/FormCliente.vue';
import {isMobile} from '../../../utils/is-celular';

export default {
    name: 'DadosDoClienteAdmin',
    methods: {
        isMobile() {
            return isMobile()
        }
    },
    components: {FormCliente, TableTelefonesClientes},
    props: {
        cliente: {
            defaultValue: null
        }
    }
};
</script>

<style scoped>

</style>
